import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { StripeService } from 'src/app/services/stripe.service';
import { AuthService } from 'src/services/auth/auth.service';
import * as env from './../../../environments/environment';
import { SettingsForPrefundProThankYouComponent } from '../settings-for-prefund-pro-thank-you/settings-for-prefund-pro-thank-you.component';
import { SettingsForPrefundProUpsellComponent } from '../settings-for-prefund-pro-upsell/settings-for-prefund-pro-upsell.component';
import { EnvironmentService } from 'src/app/services/environment.service';

@Component({
  selector: 'settings-for-prefund-pro',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    SettingsForPrefundProThankYouComponent,
    SettingsForPrefundProUpsellComponent,
  ],
  templateUrl: './settings-for-prefund-pro.component.html',
  styleUrl: './settings-for-prefund-pro.component.scss',
})
export class SettingsForPrefundProComponent {
  env = env;

  constructor(
    public authService: AuthService,
    public environment: EnvironmentService
  ) {}
}
